/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import colors from 'vuetify/lib/util/colors'
import { Vue } from 'vue-property-decorator'
import {KeyPair} from '@/types/KeyPair'

export type Validate = ((v: string | number) => string | boolean)

export default abstract class VueBase extends Vue {
  protected Colors = colors
  protected loading = true

  /* eslint-disable @typescript-eslint/explicit-function-return-type */
  get requiredRules(): Array<Validate> {
    return [v => (v === 0 || !!v) || `入力してください`]
  }

  get requiredSelectionRules(): Array<Validate> {
    return [v => (v === 0 || !!v) || `選択してください`]
  }

  get emailRules(): Array<Validate> {
    return [v => !(v === 0 || !!v) || /.+@.+\..+/.test(v?.toString()) || 'メールアドレス形式で入力してください（例: galileoscope@example.com）']
  }
  /* eslint-enable @typescript-eslint/explicit-function-return-type */

  get previewParams(): KeyPair {
    const auth = localStorage.getItem('auth')
    const authJSON = JSON.parse(auth)
    return { client: authJSON['authClient'], uid: authJSON['authUId'], token: authJSON['authAccessToken'] }
  }

  get settings(): KeyPair {
    return this.$store.getters.settings
  }

  get pathname(): string {
    return window.location.pathname
  }

  redirectToSignUp(message?: string): void {
    let href = '/users/sign_up'
    if (message) {
      href += `?message=${message}`
    }
    window.location.href = href
  }

  queryParam(key: string): string {
    return new URLSearchParams(window.location.search).get(key)
  }

  showMessage(message): void {
    this.$store.dispatch('setMessage', message)
  }

  showError(error): void {
    this.$store.dispatch('setError', error)
  }

  showLoading(): void {
    this.$store.dispatch('showLoading')
  }

  hideLoading(): void {
    this.$store.dispatch('hideLoading')
  }

  setBreadcrumbs(breadcrumbs): void {
    this.$store.dispatch('setBreadcrumbs', breadcrumbs)
  }

  showConfirm(confirm: {
    title?: any
    message?: any
    onClosed: (result: boolean) => void
  }): void {
    this.$store.dispatch('showConfirm', confirm)
  }

  hideConfirm(result: boolean): void {
    const confirm = this.$store.getters.confirm
    if (confirm && confirm.onClosed) {
      confirm.onClosed(result)
    }
    this.$store.dispatch('hideConfirm')
  }

  async writeClipBoard(id: string): Promise<void> {
    const input = document.getElementById(id) as HTMLInputElement
    input.setSelectionRange(0, input.value.length)
    document.execCommand('copy')
    this.showMessage('クリップボードにコピーされました')
  }
}
